import * as Yup from 'yup';

export interface ILoginFormInitialValues {
  email: string;
  password: string;
}

export const loginInitialValues: ILoginFormInitialValues = {
  email: '',
  password: '',
};

export const loginFormValidationSchema = Yup.object().shape({
  email: Yup.string().email().required(),
  password: Yup.string().required(),
});

export interface IForgotPasswordInitialValues {
  email: string;
}

export const forgotPasswordInitialValues: IForgotPasswordInitialValues = {
  email: '',
};

export const forgotPasswordFormValidationSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required(),
});
